import { createSlice } from '@reduxjs/toolkit';

export const getInitialState = () => ({
	username: null,
	email: null,
	avatar: null,
	signupSource: null
});

export const UserProfileSlice = createSlice({
	name: 'userProfile',
	initialState: getInitialState(),
	reducers: {
		setUserProfile: (state, action) => {
			const { username, email, avatar, signupSource } = action.payload;
			if (username !== undefined) state.username = username;
			if (email !== undefined) state.email = email;
			if (avatar !== undefined) state.avatar = avatar;
			if (signupSource !== undefined) state.signupSource = signupSource;
		},
		clearUserProfile: (state) => {
			state.username = null;
			state.email = null;
			state.avatar = null;
			state.signupSource = null;
		}
	}
});

export const {
	setUserProfile,
	clearUserProfile,
} = UserProfileSlice.actions;

export default UserProfileSlice.reducer;

